import React from 'react';
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { TypographyProps } from "@mui/material";


interface CustomTypographyI extends TypographyProps {
    truncate?: boolean
}

const CustomTypography = (props: CustomTypographyI) => {
    return (
        <>
            {props.truncate ? <Tooltip title={props.children}>
                <Typography {...props} sx={{
                    ...props.sx, ...{
                        "overflow": "hidden",
                        "textOverflow": "ellipsis",
                        "whiteSpace": "nowrap"
                    }
                }}>
                    {props.children}
                </Typography>
            </Tooltip> : <Typography {...props} >
                {props.children}
            </Typography>}
        </>
    );
};

export default CustomTypography;
